// pages/CompetencyQuiz/useSingleFlight.js
//
// Owner 2026-10-26: "make sure there are no double clicks to the server". A disabled button
// only takes effect after React re-renders, so a fast double-click can fire the handler twice.
// run(key, fn) is a synchronous lock: while a call for `key` is running, further calls for the
// same key are ignored. Use one key per action (e.g. "start", "assign:3325").
import { useCallback, useRef } from "react";

export default function useSingleFlight() {
    const running = useRef(new Set());
    return useCallback(async (key, fn) => {
        if (running.current.has(key)) return undefined;
        running.current.add(key);
        try {
            return await fn();
        } finally {
            running.current.delete(key);
        }
    }, []);
}
